/** README 
 *  封装公共接口：下载
 *        >>> 
 * 
 * 
 *  待完善：
 *        1- 将消息提示框，在实例化时注入
 *            >>> 模块化，不应强依赖某个自定义脚本或插件！
 *            >>> window.dispatchNotify
 *            >>> ElLoading
 * 
 * 
 */


import { httpBus } from "@/api/index.js";
import { tansParams, blobValidate } from "@/utils/index.js";
import { ElLoading } from "element-plus";
import { saveAs } from "file-saver";


let loadingInstance = null;

/**
 * 通用下载方法 >>> 方式1
 * @param {*} url 
 * @param {*} params 
 * @param {*} filename 
 * @returns 
 */
export function download(url, params, filename) {
  loadingInstance = ElLoading.service({
    text: $str.getKey('全局/正在下载数据，请稍候'),
    background: "rgba(0, 0, 0, 0.7)"
  });
  const config = {
    transformRequest: [(params) => { return tansParams(params); }],
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    responseType: "blob"
  };
  return httpBus.post(url, params, config).then(async (data) => {
    const isBlob = await blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data]);
      saveAs(blob, filename);
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = httpBus.errorCode[rspObj.code] || rspObj.msg || httpBus.errorCode["default"];
      // window.dispatchNotify(errMsg);
      window.dispatchNotify({
        type: 'error',
        message: errMsg
      });
    }
    loadingInstance.close();
  })
  .catch(r => {
    console.error(r);
    // window.dispatchNotify('下载文件出现错误，请联系管理员！')
    window.dispatchNotify({
      type: 'error',
      message: $str.getKey('全局/下载文件出现错误，请联系管理员！')
    });
    loadingInstance.close();
  });
}

/**
 * 通用下载方法 >>> 方式2
 * @param {*} url 
 * @param {*} params 
 * @param {*} filename 
 * @returns 
 */
export function download2(url, params, filename) {
  loadingInstance = ElLoading.service({ text: $str.getKey('全局/正在下载数据，请稍候'), background: "rgba(0, 0, 0, 0.7)", });
  const config = {
    responseType: 'blob',
    data: params,
  };
  return httpBus.post(url, params, config).then(async (data) => {
    const isBlob = await blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data]);
      saveAs(blob, filename)
    } else {
      const resText = await data.text()
      const rspObj = JSON.parse(resText)
      const errMsg = httpBus.errorCode[rspObj.code] || rspObj.msg || httpBus.errorCode['default']
      window.dispatchNotify({ type: 'error', message: errMsg })
    }
    loadingInstance.close()
  }).catch(r => {
    console.error(r)
    window.dispatchNotify({ type: 'error', message: $str.getKey('全局/下载文件出现错误，请联系管理员！') })
    loadingInstance.close()
  })
}

/**
 * 通用下载方法 >>> 方式3-get
 * @param {*} url 
 * @param {*} params 
 * @param {*} filename 
 * @returns 
 */
export function download_get(url, params, filename) {
  loadingInstance = ElLoading.service({ text:$str.getKey('全局/正在下载数据，请稍候'), background: "rgba(0, 0, 0, 0.7)", });
  const config = {
    responseType: 'blob',
  };
  return httpBus.get(url, params, config).then(async (data) => {
    const isBlob = await blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data]);
      saveAs(blob, filename)
    } else {
      const resText = await data.text()
      const rspObj = JSON.parse(resText)
      const errMsg = httpBus.errorCode[rspObj.code] || rspObj.msg || httpBus.errorCode['default']
      window.dispatchNotify({ type: 'error', message: errMsg })
    }
    loadingInstance.close()
  }).catch(r => {
    console.error(r)
    window.dispatchNotify({ type: 'error', message: $str.getKey('全局/下载文件出现错误，请联系管理员！') })
    loadingInstance.close()
  })
}





